<template>
  <ConfigProvider :theme-vars="themeVars">
    <div class="activity-coupon" v-if="activeData.id">
      <div class="bg">
        <img v-if="activeData.headImage" :src="activeData.headImage" alt="" />
      </div>
      <div class="rule-desc" @click="toPolicyPage(activeData.eventActivityDescription)">
        <img src="@/static/image/activity-coupon/icon_rule.png" alt="" />
      </div>
      <div class="input-block" v-if="!receiveStatue">
        <div class="input-line">
          <Field
            v-model="phone"
            label-class="input-label"
            label-width="63"
            maxlength="11"
            type="digit"
            center
            clearable
            label="手机号"
            placeholder="请输入手机号"
          >
          </Field>
        </div>
        <div class="input-line">
          <Field
            v-model="code"
            label-class="input-label"
            label-width="63"
            maxlength="4"
            type="digit"
            center
            label="验证码"
            placeholder="请输入验证码"
          >
            <template #button>
              <div
                class="send-code"
                :class="{ grey: isCodeBtn, disabled: phone.length !== 11 }"
                @click="getCode"
              >
                {{ codeBtn }}
              </div>
            </template>
          </Field>
        </div>
        <div class="input-rule">
          <div class="rule-check" @click="isAgree = !isAgree">
            <img
              v-if="!isAgree"
              src="@/static/image/activity-coupon/icon_check_nor.png"
              alt=""
            />
            <img v-else src="@/static/image/activity-coupon/icon_check_sel.png" alt="" />
          </div>
          <div class="rule-text">
            我已仔细阅读并同意
            <div class="text" @click="toPolicyPage('TK001')">《用户服务协议》</div>
            <div class="text" @click="toPolicyPage('TK002')">《隐私政策》</div>
          </div>
        </div>
        <div class="input-btn" @click="handlerSubmit(false)">一键领取优惠券</div>
      </div>
      <div class="receive-block" v-else>
        <div class="receive-content" :class="{'bg-pink': activeData.activityStatus === 3 && activeData.checkStock}">
          <img v-if="activeData.activityStatus === -1" class="receive-content__icon" src="@/static/image/activity-coupon/icon_waiting.png" alt />
          <img v-else-if="activeData.activityStatus === 5 || activeData.checkStock === false" class="receive-content__icon" src="@/static/image/activity-coupon/icon_disabled.png" alt />
          <img v-else class="receive-content__icon" src="@/static/image/activity-coupon/checked_fill.png" alt />
          
          <div v-if="activeData.activityStatus !== 3" class="receive-title receive-title-desc">
            {{activeData.activityStatus === -1 ? '活动未开始' : '活动已结束'}}
          </div>
          <div v-else-if="activeData.checkStock === false" class="receive-title receive-title-desc">
            优惠券已领完
          </div>
          <div v-else class="receive-title">
            领取成功，快去订阅吧!
          </div>
          <div class="receive-bottom">
            <div class="left">
              <div class="line1">长按识别或{{hasAliApp ? '支付宝' : '微信'}}搜索【极氪订阅】</div>
              <div class="line2">{{ activeData.activityStatus === 3 && activeData.checkStock ? '优惠券在【我的】-【我的卡券】中查收使用' : '进入极氪订阅小程序获取更多活动资讯'}}</div>
            </div>
            <div class="right">
              <img v-if="hasAliApp" src="@/static/image/activity-coupon/qrcode_alipay.png" alt />
              <img v-else src="@/static/image/activity-coupon/qrcode_wechat.png" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="agree-popup-block" v-if="agreePopup">
        <div class="agree-popup-mask"></div>
        <div class="agree-popup">
          <div class="agree-title">请阅读并同意以下条款</div>
          <div class="agree-content">
            我已仔细阅读并同意<div class="text" @click="toPolicyPage('TK001')">《用户服务协议》</div>
          </div>
          <div class="text" @click="toPolicyPage('TK002')">《隐私政策》</div>
          <div class="agree-btn-flex">
            <div class="agree-btn agree-btn-cancel" @click="agreePopup = false">取消</div>
            <div class="agree-btn agree-btn-confirm" @click="handlerSubmit(true)">同意并领取</div>
          </div>
        </div>
      </div>
    </div>
  </ConfigProvider>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import './index.scss'
import { getCouponActivity, getCouponMessage, getCouponReceive } from '@/api/udp'
import { Toast, Field, Button, ConfigProvider } from 'vant'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const ua = window.navigator.userAgent.toLowerCase();
const hasAliApp = ref(ua.indexOf("aliapp") > -1);
const phone = ref('')
const code = ref('')
const codeBtn = ref('获取验证码')
const isCodeBtn = ref(false)
const activeData = ref({})
const receiveStatue = ref(false)
const agreePopup = ref(false)
const isAgree = ref(false)
const  isLoading = ref(false)
const themeVars = ref({
  fieldInputTextColor: '#232323',
  fieldPlaceholderTextColor: '#B9BEC0',
  fieldInputFontSize: '16px',
  fieldPlaceholderFontSize: '16px'
})

onMounted(() => {
  init()
})
const init = () => {
  getCouponActivity(route.query.id).then(res => {
    if (res.status === 200 && res.data.code === '0') {
      const titleDom = document.querySelector('title')
      if (titleDom && res.data.body.eventActivityName) {
        titleDom.innerHTML = res.data.body.eventActivityName
      }
      if(res.data.body.activityStatus !== 3 || res.data.body.checkStock === false) {
        receiveStatue.value = true
        console.log('receiveStatue.value', receiveStatue.value)
      }
      activeData.value = res.data.body
      if(localStorage.getItem('a_phone')) {
        phone.value = localStorage.getItem('a_phone')
        code.value = localStorage.getItem('a_code')
      }
    } else {
      Toast((res.data && res.data.msg) || '查询失败')
    }
  })
}
const validatePhone = phone => {
  // 手机号正则表达式校验
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phone)
}
const getCode = () => {
  // eslint-disable-next-line no-console
  if (isCodeBtn.value) {
    return
  }
  if (!validatePhone(phone.value)) {
    Toast('请输入正确的手机号')
    return
  }
  getCouponMessage({
    phone: phone.value,
    activityCode: route.query.id
  }).then(res => {
    if (res.data.code === '0') {
      Toast('验证码发送成功')
      isCodeBtn.value = true
      codeBtn.value = '59s'
      let time = 59
      const timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer)
          codeBtn.value = '重新获取'
          isCodeBtn.value = false
        } else {
          codeBtn.value = `${time--}s`
        }
      }, 1000)
    } else {
      Toast((res.data && res.data.msg) || '验证码发送失败')
    }
  })
}

const toPolicyPage = clauseCode => {
  localStorage.setItem('a_phone', phone.value)
  localStorage.setItem('a_code', code.value)
  router.push({
    name: 'PolicyPage',
    params: {
      id: clauseCode
    },
    query: {
      token: '421459faa4e1f6d564f67d138620be8d'
    }
  })
}
const handlerSubmit = (skip) => {
  if(skip) {
    isAgree.value = true
  }
  if (!validatePhone(phone.value)) {
    Toast('请输入正确的手机号')
    return
  }
  if (!code.value) {
    Toast('请输入验证码')
    return
  }
  if (!isAgree.value) {
    agreePopup.value = true
    return
  }
  isLoading.value = true
  getCouponReceive({
    phone: phone.value,
    activityCode: route.query.id,
    captchaCode: code.value
  }).then(res => {
    if (res.status === 200 && res.data.code === '0') {
      Toast('领取成功')
      receiveStatue.value = true
      agreePopup.value = false
    } else {
      init()
      Toast((res.data && res.data.msg) || '领取失败')
    }
    setTimeout(() => {
      isLoading.value = false
    }, 500);
  }).finally(() => {
    localStorage.setItem('a_phone', "")
    localStorage.setItem('a_code', "")
    isLoading.value = false
  })
}
</script>
